import angular from 'angular';

angular.module('cloudX').directive('cxSortIcon', [
  function() {
    var nameFromToStringRegex = /^function\s?([^\s(]*)/;

    function className(object, defaultName) {
      var result = '';
      if (typeof object === 'function') {
        result = object.name || object.toString().match(nameFromToStringRegex)[1];
      } else if (typeof object.constructor === 'function') {
        result = className(object.constructor, defaultName);
      }
      return result || defaultName;
    }

    return {
      restrict: 'E',
      replace: true,
      template:
        '<i class="glyphicon margin10L" ng-show="visible()" ng-class="reverse?\'glyphicon-triangle-bottom\':\'glyphicon-triangle-top\'"></i>',
      scope: {
        key: '@?',
        func: '=?',
        predicate: '=',
        reverse: '=',
      },
      controller: [
        '$scope',
        function($scope) {
          $scope.visible = function() {
            if (typeof $scope.func === 'function' && typeof $scope.predicate === 'function')
              return $scope.func === $scope.predicate;
            if (typeof $scope.key === 'undefined' || typeof $scope.predicate === 'undefined')
              return false;
            if (angular.isArray($scope.predicate)) return $scope.key === $scope.predicate[0];
            return $scope.key === $scope.predicate;
          };
        },
      ],
    };
  },
]);
